import React from 'react';
import { Form, Col, Row, Select, Spin } from 'antd';
import { FormInstance } from 'antd/lib/form';
import HeroTitle from 'components/theme_components/HeroTitle';
import ContactCard from './ContactCard';
import { getThirdPartyContactByid, getThirdPartyContractListByTpid } from 'services/thirdParty';
import { useQuery } from 'react-query';
import ContactModal from './ContactModal';
import ModalSFS from 'components/theme_components/ModalSFS';
import Title from 'components/Title';
import { PlusOutlined } from '@ant-design/icons';
import GetLabel from 'DisplayFramework/components/GetLabel';

export type ContactsListProps = {
  tpid: number;
  form: FormInstance;
  color: string;
  itemsCompanyHierarchyTree: any[];
  tptype: string;
};

const ContactsList = ({ form, tpid, color, itemsCompanyHierarchyTree, tptype }: ContactsListProps) => {

  const { data: contacts, refetch, isFetching } = useQuery(
    ['getThirdPartyContractListByTpid', { tpid: Number(tpid) }],
    () =>
      getThirdPartyContractListByTpid({ tpid: Number(tpid) }).then(
        (res) => res.list || []
      ), { refetchOnWindowFocus: false }

  );
  return (

    <Form form={form} className="">
      <HeroTitle
        form={form}
        display
        color={color}
        title={`contact${tptype}`}
        itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
      />



      <div style={{ padding: '40px 24px' }}>

        <Row gutter={[16, 16]} justify="center" className="ml-0 mr-0 pb-20">
          {contacts &&
            contacts.map((contact, index) => (

              <Col span={20} className='align-center' key={index}>

                <ContactCard hideDeletebtn={contacts.length == 1} contact={contact} tpid={tpid} refetch={refetch} index={index + 1} />
              </Col>))}
        </Row>
        <Row gutter={[16, 16]} justify="center" className="ml-0 mr-0 pb-20 mt-20" style={{ marginTop: 30 }}>
          <Col>
            <ModalSFS
              trigger={({ setVisible }) => (
                <>
                  <a onClick={() => setVisible(true)} style={{ display: 'flex' }}>
                    <PlusOutlined className="color-orange font-size-16 cursorpointer" style={{ marginRight: '13px' }} />

                    <GetLabel
                      label="addcontact"
                      className="font-size-18 floatRight ml-14 cursorpointer"
                      style={{ color: '#4B5672', fontWeight: 500 }}
                    />

                  </a>
                </>

              )}
              title="addcontact"
            >
              <ContactModal
                tpid={Number(tpid)}
                setVisible={() => false}
                refetch={refetch}
              />
            </ModalSFS>
          </Col>
        </Row>
      </div>


    </Form>
  )
};

export default ContactsList;
